import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';
import { createEntityEffects } from '../../../shared/base';
import {
  CreateSubcategoryCommand,
  GetAllSubcategoriesCommand,
  UpdateSubcategoryCommand,
  UpdateStateSubcategoryCommand,
  GetSubcategoriesByCategoryIdCommand,
  GetAllSubcategoriesByStatusesCommand,
} from './subcategory.commands';
import {
  CreatedSubcategoryEvent,
  GotAllSubcategoriesEvent,
  UpdatedSubcategoryEvent,
  UpdatedStateSubcategoryEvent,
} from './subcategory.events';

@Injectable()
export class SubcategoryEffects {
  prefix = 'subcategory';

  createSubcategoryCommand: Observable<Action<string>> & CreateEffectMetadata;
  getAllSubcategoriesCommand: Observable<Action<string>> & CreateEffectMetadata;
  updateSubcategoryCommand: Observable<Action<string>> & CreateEffectMetadata;
  updateStateSubcategoryCommand: Observable<Action<string>> & CreateEffectMetadata;
  getSubcategoriesByCategoryIdCommand: Observable<Action<string>> & CreateEffectMetadata;
  getAllSubcategoriesByStatusesCommand: Observable<Action<string>> & CreateEffectMetadata;

  constructor(private sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.createSubcategoryCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      CreateSubcategoryCommand,
      CreatedSubcategoryEvent,
      this.prefix,
    );
    this.getAllSubcategoriesCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetAllSubcategoriesCommand,
      GotAllSubcategoriesEvent,
      this.prefix,
    );
    this.updateSubcategoryCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      UpdateSubcategoryCommand,
      UpdatedSubcategoryEvent,
      this.prefix,
    );
    this.updateStateSubcategoryCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      UpdateStateSubcategoryCommand,
      UpdatedStateSubcategoryEvent,
      this.prefix,
    );
    this.getSubcategoriesByCategoryIdCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetSubcategoriesByCategoryIdCommand,
      GotAllSubcategoriesEvent,
      this.prefix,
    );
    this.getAllSubcategoriesByStatusesCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetAllSubcategoriesByStatusesCommand,
      GotAllSubcategoriesEvent,
      this.prefix,
    );
  }
}
